import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { ErpSyncValidationPage } from '@pages/erp-sync-validation';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/validation')({
  validateSearch: z.object({
    contract: z.string().optional(),
  }),
  component: ErpSyncValidationRoute,
});

function ErpSyncValidationRoute() {
  const { locale } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  return (
    <ErpSyncValidationPage
      initialContractKey={search.contract}
      onOpenMapping={(contractKey) => {
        void navigate({
          to: '/$locale/erp-sync/mapping',
          params: { locale },
          search: { contract: contractKey },
        });
      }}
    />
  );
}
